import { Box } from "@mui/material";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { colors } from "../../../constants/colors";
import {
  AnnounceCardShell,
  AnnounceChip,
  AnnounceTitle,
  MetaLabel,
  MetaValue,
} from "./announceView.style";
import {
  AnnounceMetaItem,
  announceChipLabel,
  getAnnounceMeta,
} from "./announceView.utils";

type Props = {
  announce: any;
  /** ลำดับสไลด์ที่แสดงมุมขวาบน เช่น "1 / 5" — ไม่ส่งมาก็ไม่ขึ้น */
  counter?: string;
  onReadMore: () => void;
};

const renderMeta = (item: AnnounceMetaItem, index: number) => (
  <Box key={`${item.label}-${index}`} sx={{ minWidth: 0 }}>
    <MetaLabel>{item.label}</MetaLabel>
    {item.isDate ? (
      <MetaValue
        sx={{
          color: colors.themeMainColor,
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <CalendarMonthOutlinedIcon sx={{ fontSize: 18 }} />
        {item.value}
      </MetaValue>
    ) : (
      <MetaValue>{item.value}</MetaValue>
    )}
  </Box>
);

/** การ์ดประกาศ 1 ใบใน carousel ข่าวสารหน้าหลัก */
export default function AnnounceNewsCard({
  announce,
  counter,
  onReadMore,
}: Props) {
  return (
    <AnnounceCardShell>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "12px",
        }}
      >
        <AnnounceChip>
          <CampaignOutlinedIcon sx={{ fontSize: 18 }} />
          {announceChipLabel(announce)}
        </AnnounceChip>
        {counter && (
          <MetaLabel sx={{ whiteSpace: "nowrap" }}>{counter}</MetaLabel>
        )}
      </Box>

      <AnnounceTitle sx={{ marginTop: "14px" }}>
        {announce?.title || "-"}
      </AnnounceTitle>

      <Box
        sx={{
          marginTop: "18px",
          display: "flex",
          flexWrap: "wrap",
          gap: "18px 44px",
        }}
      >
        {getAnnounceMeta(announce, "ช่วงเวลาในการลงทะเบียน").map(renderMeta)}
      </Box>

      <Box
        onClick={onReadMore}
        sx={{
          marginTop: "22px",
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          backgroundColor: colors.themeMainColor,
          color: colors.white,
          fontFamily: "Kanit",
          fontSize: "16px",
          borderRadius: "8px",
          padding: "9px 12px 9px 20px",
          cursor: "pointer",
          transition: "0.2s",
          ":hover": { opacity: 0.88 },
        }}
      >
        อ่านเพิ่มเติม
        <ChevronRightIcon sx={{ fontSize: 20 }} />
      </Box>
    </AnnounceCardShell>
  );
}
